  <template>
  <div>
  <b-modal style="padding:15px" size="lg" id="AddDepoModal" ref="modal" title="Add Depot" ok-title="Submit" cancel-title="Close" 
      @show= "resetModal()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddDepoForm != undefined ? !this.$refs.AddDepoForm.checkValidity() : true">
        <form ref="AddDepoForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-4">
              <!--NAME INPUT-->
               <b-form-group  label="Name" label-for="Name" autocomplete="off">
                <b-form-input id="Name" v-model= "Name" type = "text"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group  label="Phone Number" label-for="PhoneNumber" autocomplete="off">
                <b-form-input id="PhoneNumber" v-model= "PhoneNumber" type = "text"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group  label="Address" label-for="Address" autocomplete="off">
                <b-form-input id="Address" v-model= "Address" type = "text" required></b-form-input>
              </b-form-group>
            </div>
          </div>
                  
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
    </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'AddDepot',
    data(){
        return{
          moduleName:'Add Depot',
          Name:null,
          PhoneNumber:null,
          Address:null,     
		}
  },
components:{
Toaster
},
methods:{

    AddDepo(){ 
     
     axios.post('/depo/Add', 
      {"Name":this.Name,"PhoneNumber":this.PhoneNumber, "Address":this.Address,
      "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id
      
      })
      .then(res=>{
        console.log(res)
            if(res.data.status == 1)
            {
               
                this.$refs.toaster.showToast('Sucess','success','Depot has been added successfully')
                 this.$bvModal.hide('AddDepoModal')
                 this.$parent.getDepos();      
            }
             else if(res.data.status == -1)
            {
                 this.$refs.toaster.showToast('Error','danger',res.data.msg)
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddDepoForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.Address = null;
        this.PhoneNumber = null;
        this.Name = null; 
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.AddDepo()
        
       
      },
 
  
  },
	

}
</script>
